import exists from "modules/exists";

export default (prop) =>
  Array.isArray(prop)
    ? !prop.includes(null) && !prop.includes(undefined) && prop.every(exists)
    : !!prop && prop !== null;
